// extracted by mini-css-extract-plugin
module.exports = {"w1yut6hb":"w1yut6hb","c1esjvzp":"c1esjvzp"};